import React, { useState, useCallback, useEffect, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Spinner from "../app/shared/Spinner";

// ------------------ Navigation -------------------
const Dashboard = lazy(() => import("./dashboard"));

// --- LoginRegistration ---
const Login = lazy(() => import("./login"));

//Menu Permissions
const MenuPermissions = lazy(() => import("./menuPermissions"));
const MenuPermissionsEdit = lazy(() => import("./menuPermissions/edit"));

// --- Workers ---
const Workers = lazy(() => import("./workers"));
const WorkersAdd = lazy(() => import("./workers/add"));
const WorkersEdit = lazy(() => import("./workers/edit"));
const WorkersView = lazy(() => import("./workers/view"));
const WorkerCompanies = lazy(() => import("./workers/companies"));

// --- Help ---
const Help = lazy(() => import("./help"));
const HelpAdd = lazy(() => import("./help/add"));
const HelpEdit = lazy(() => import("./help/edit"));

// --- Company ---
const Company = lazy(() => import("./company"));
const CompanyView = lazy(() => import("./company/view"));
const CompanyEdit = lazy(() => import("./company/edit"));

// --- Tools ---
const Tools = lazy(() => import("./company/view/tools"));
const ToolAdd = lazy(() => import("./company/view/tools/add"));
const ToolEdit = lazy(() => import("./company/view/tools/edit"));
const ToolView = lazy(() => import("./company/view/tools/view"));

// --- Payment ---
const Payment = lazy(() => import("./company/view/payment"));

// --- Rates ---
const Rates = lazy(() => import("./company/view/rates"));

// ------------------ END Navigation -------------------

// ------------------ Example -------------------
const Buttons = lazy(() => import("./basic-ui/Buttons"));
const Dropdowns = lazy(() => import("./basic-ui/Dropdowns"));
const Typography = lazy(() => import("./basic-ui/Typography"));
const BasicTable = lazy(() => import("./tables/BasicTable"));
const Mdi = lazy(() => import("./icons/Mdi"));
// ------------------ END Example -------------------

function protectedRoute(PageComponent) {
  return function (props) {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      const backUrl = encodeURIComponent(props.location.pathname);
      return <Redirect to={`/login?redirect-url=${backUrl}`} />;
    }

    return <PageComponent {...props} />;
  };
}

function AppRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        {/* ------------------Navigation--------------- */}
        <Route exact path="/dashboard" component={protectedRoute(Dashboard)} />

        <Route
          exact
          path="/menu-permissions"
          component={protectedRoute(MenuPermissions)}
        />
        <Route
          exact
          path="/menu-permissions/:id/edit"
          component={protectedRoute(MenuPermissionsEdit)}
        />

        <Route exact path="/workers" component={protectedRoute(Workers)} />
        <Route
          exact
          path="/workers/create"
          component={protectedRoute(WorkersAdd)}
        />
        <Route
          exact
          path="/workers/:id/edit"
          component={protectedRoute(WorkersEdit)}
        />
        <Route
          exact
          path="/workers/:id"
          component={protectedRoute(WorkersView)}
        />
        <Route
          exact
          path="/workers/:id/companies"
          component={protectedRoute(WorkerCompanies)}
        />

        <Route exact path="/companies" component={Company} />
        <Route
          exact
          path="/companies/:id"
          component={protectedRoute(CompanyView)}
        />
        <Route
          exact
          path="/companies/:id/edit"
          component={protectedRoute(CompanyEdit)}
        />
        <Route exact path="/tools" component={Tools} />
        <Route exact path="/tools/add" component={protectedRoute(ToolAdd)} />
        <Route
          exact
          path="/tools/edit/:id"
          component={protectedRoute(ToolEdit)}
        />
        <Route
          exact
          path="/tools/view/:id"
          component={protectedRoute(ToolView)}
        />

        <Route exact path="/payment" component={protectedRoute(Payment)} />
        

        <Route exact path="/rates" component={protectedRoute(Rates)} />

        <Route exact path="/help" component={protectedRoute(Help)} />
        <Route
          exact
          path="/help/create"
          component={protectedRoute(HelpAdd)}
        />
        <Route
          exact
          path="/help/:id/edit"
          component={protectedRoute(HelpEdit)}
        />

        {/* ------------------ENDNavigation--------------- */}

        {/* ------------------Example--------------- */}
        <Route exact path="/basic-ui/buttons" component={Buttons} />
        <Route exact path="/basic-ui/dropdowns" component={Dropdowns} />
        <Route exact path="/basic-ui/typography" component={Typography} />
        <Route exact path="/tables/basic-table" component={BasicTable} />
        <Route exact path="/icons/mdi" component={Mdi} />
        <Route exact path="/login" component={Login} />

        {/* ------------------ENDExample--------------- */}

        <Redirect to="/dashboard" />
      </Switch>
    </Suspense>
  );
}

export default AppRoutes;
